module.exports = __webpack_public_path__ + "img/7.4b6e1f46.png";